var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LiefengContent',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("广州市“社区随约服务网上驿站”用户数据统计")]},proxy:true},{key:"contentArea",fn:function(){return [_c('div',{attrs:{"id":"container"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }